import { Breadcrumbs } from '../components/Breadcrumbs';
import { Callout } from '../components/Callout';
import { MediaFrame } from '../components/MediaFrame';
import { Reveal } from '../components/Reveal';
import { ResponsiveImage } from '../components/ResponsiveImage';
import { projects } from '../content/site';

export function Projects() {
  return (
    <>
      <section className="page-hero section-shell">
        <Breadcrumbs items={[{ label: 'Projects' }]} />
        <div className="page-hero__grid">
          <Reveal><p className="section-kicker">Selected work</p><h1>Outdoor spaces and masonry details made to be seen.</h1></Reveal>
          <Reveal delay={0.08}><p className="page-hero__lede">Explore real paver patios, driveways, masonry, tile, and manufactured stone work. Look closely at the patterns, clean edges, and transitions that bring a premium finish to the property.</p></Reveal>
        </div>
      </section>
      <section className="project-gallery section-pad section-shell" aria-label="Vic's Bricks project photographs">
        {projects.map((project, index) => (
          <Reveal as="figure" key={project.title} delay={Math.min(index * 0.05, 0.2)} variant="media">
            <MediaFrame className="project-gallery__media">
              <ResponsiveImage
                src={project.image}
                alt={project.alt}
                width="1000"
                height="750"
                loading={index < 2 ? 'eager' : 'lazy'}
                sizes="(max-width: 767px) calc(100vw - 24px), min(48vw, 650px)"
                style={{ objectPosition: project.imagePosition }}
              />
            </MediaFrame>
            <figcaption>
              <div><h2>{project.title}</h2><p>{project.caption}</p></div>
              <span><b aria-hidden="true">{String(index + 1).padStart(2, '0')}</b>{project.category}<small>{project.location}</small></span>
            </figcaption>
          </Reveal>
        ))}
      </section>
      <Callout title="Have a property with a similar need?" text="Send the location, the service, and a short description of what you want to change." />
    </>
  );
}
